import React from 'react';
import { useTranslation } from 'react-i18next';

import { QStack, QText } from '@captivateiq/quotient';


import { suiteAgentIconUrl } from '@captivateiq/assistant/assets';

import { useAgentDiscovery } from '@captivateiq/assistant/hooks/useAgentDiscovery';
import { AgentCard } from './AgentCard';
import { TabLayout } from '../../TabLayout';

export const BrowserView = () => {
  const { t } = useTranslation('assistant');
  const { availableAgents, loading, error } = useAgentDiscovery();

  return (
    <TabLayout>
      <QStack
        direction="row"
        spacing="10px"
        sx={{
          justifyContent: 'stretch',
          padding: '12px',
        }}
      >
        <img alt="AI Assistant" height={40} src={suiteAgentIconUrl} style={{ borderRadius: '8px' }} width={40} />
        <QText
          sx={{
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '20px',
            color: 'text.onSurface.background.mediumContrast',
          }}
        >
          {t('browser_welcome')}
        </QText>
      </QStack>

      {loading && (
        <QStack sx={{ padding: '12px' }}>
          <QText sx={{ color: 'text.onSurface.background.mediumContrast' }}>
            {t('loading_agents', 'Loading available agents...')}
          </QText>
        </QStack>
      )}

      {error && (
        <QStack sx={{ padding: '12px' }}>
          <QText sx={{ color: 'error.main' }}>
            {t('error_loading_agents', 'Error loading agents: {{error}}', { error })}
          </QText>
        </QStack>
      )}

      {!loading && !error && availableAgents.length === 0 && (
        <QStack sx={{ padding: '12px' }}>
          <QText sx={{ color: 'text.onSurface.background.mediumContrast' }}>
            {t('no_agents_available', 'No agents are currently available for this page.')}
          </QText>
        </QStack>
      )}

      {!loading && !error && availableAgents.map((agent) => <AgentCard agent={agent} key={agent.name} />)}
    </TabLayout>
  );
};
